import React from 'react';
import { useDispatch } from 'react-redux';
import useEditProfileMask from '../../../hooks/use-edit-profile-mask';
import { closeMetaMenu } from '../../../stores/actions/tabs';
import { setModalOpen } from '../../../stores/actions/modal';

interface Props {
	email: string;
}

export default function DeleteMask(props: Props) {
	const { email } = props;
	const dispatch = useDispatch();

	const {detachMask} = useEditProfileMask({});

	const deleteMask = async () => {
		if (email) {
			await detachMask(email);
			dispatch(closeMetaMenu());
			dispatch(setModalOpen(false));
		}
	};

	return (
		<div className="info-modal confirmation-dialog delete-event" data-testid="delete-account-modal">
			<h4>Are you sure you want to remove this profile override?</h4>
			<div className="text-content">
				This will detach the profile from the user's information at a channel-wide level.
			</div>
			<div className="button-group">
				<button className="green" onClick={() => dispatch(setModalOpen(false))}>Cancel</button>
				<button className="gray" onClick={deleteMask} data-testid="delete-account-btn">
					<span>Delete</span>
				</button>
			</div>
		</div>
	);
}
